document.addEventListener('DOMContentLoaded', function() {
    const menuDrawer = document.getElementById('mobileMenuDrawer');
    const openButton = document.getElementById('openDrawerBtn'); // Adjust the selector for your open button
    const closeButton = document.getElementById('closeDrawerBtn');
    const collapsibleTriggers = document.querySelectorAll('.collapsible-trigger');
  
    openButton.addEventListener('click', function() {
      menuDrawer.classList.add('open');
    });
  
    closeButton.addEventListener('click', function() {
      menuDrawer.classList.remove('open');
    });

    collapsibleTriggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
          const submenu = this.nextElementSibling;
          submenu.classList.toggle('open');
          this.classList.toggle('is-open');
        });
      });
  });
  